import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-input__wrapper" }
const _hoisted_2 = ["placeholder"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "search-input",
      type: "text",
      placeholder: $props.placeholderText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.searchValue) = $event)),
      onInput: _cache[1] || (_cache[1] = (...args) => ($options.handleSearch && $options.handleSearch(...args)))
    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2), [
      [_vModelText, $data.searchValue]
    ]),
    (!!$data.searchValue)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "clear-icon fas fa-times",
          onClick: _cache[2] || (_cache[2] = (...args) => ($options.clearSearch && $options.clearSearch(...args)))
        }))
      : _createCommentVNode("v-if", true)
  ]))
}